<template>
  
    <md-boards :md-auto="true" :md-infinite="true" :md-duration="10000" :md-swipeable="true">
      <md-board id="slide1">
        <img src='../assets/onboarding1.png' class="onboarding-image" />
      </md-board>

      <md-board id="slide2">
        <img src='../assets/onboarding2.png' class="onboarding-image" />  
      </md-board>

      <md-board id="slide3">
        <img src='../assets/onboarding3.png' class="onboarding-image" />
      </md-board>
    </md-boards>
  
  
</template>

<script>
export default {
  name: 'onboarding',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style>
  .onboarding-image{
    
  }
  .md-boards {
   height: auto !important;
  }

</style>


// WEBPACK FOOTER //
// Onboarding.vue?75b94286